module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAElBMVEVHcEyYmJiYmJiYmJiYmJiYmJhddS7DAAAABnRSTlMA/+JpMbCSjg0/AAAATklEQVQI12NgVWGAAENBBwhDUVABwhAUFIaJQBmBggFoiplgDGaYFIMiVDGDo6ABA4sBWE7UIVDIAawPCESADBZFEAusEcgSghgRpBQAANNQB2q8d52MAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone2.png
// module id = m0+L
// module chunks = 1